import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { Row } from "views/applications-id-report/components/Row";
import { Declarations } from "../types";

const DECLARATIONS: { title: string; key: keyof Declarations }[] = [
  { title: "Primary residence", key: "isPrimaryResidence" },
  {
    title: "Ownership interest in another property",
    key: "hasOwnershipInterest"
  },
  {
    title: "Prior foreclosure or short sale",
    key: "previousForeclosureOrShortSale"
  },
  { title: "Declared bankruptcy", key: "hasBankruptcy" },
  { title: "U.S. citizen", key: "citizenshipStatus" },
  { title: "Permanent resident", key: "permanentResident" }
];

const YesNo = ({ value }: { value: boolean }) => (
  <Badge
    variant={value ? BadgeVariant.SUCCESS : BadgeVariant.BASE}
    size={BadgeSize.SM}
  >
    {value ? "Yes" : "No"}
  </Badge>
);

export const DeclarationsList = ({
  declarations
}: {
  declarations: Declarations;
}) => (
  <div className="space-y-2">
    {DECLARATIONS.map(({ title, key }) => (
      <Row
        key={key}
        fullWidthRow
        title={title}
        value={<YesNo value={declarations[key]} />}
      />
    ))}
  </div>
);
